import {
	MimaButton,
	MimaDateInput,
	MimaDropdown,
	MimaInput,
	MimaText,
	MimaTextArea,
	Modal,
	ReceiptCheckBox as RCB,
} from '../../components';
import styles from '../../assets/styles/Customer/Customer.module.scss';
import {  employeeStore } from '../../stores';
import { Formik } from 'formik';
import React from 'react';
import { toJS } from 'mobx';

const AddLoan = ({
	closeModal,
	validationSchema,
	onSubmit,
	loading,
	goBack,
}) => {
	return (
		<Modal closeModal={closeModal} goBack={goBack}>
			<MimaText variant="subtitle" color="var(--color-primary)" align="center">
				Add Employee Loan
			</MimaText>
			<Formik
				initialValues={{
					employee: '',
					employeeName: '',
					amountCollected: 0,
					rePaymentMonths: 0,
					disbursementDate: '',
					dateOfFirstRePayment: '',
					description: '',
				}}
				validationSchema={validationSchema}
				onSubmit={onSubmit}>
				{({
					handleChange,
					handleBlur,
					handleSubmit,
					setFieldValue,
					values,
					errors,
					touched,
				}) => (
					<div>
						<MimaDropdown
							labelTitle="Select Employee"
							placeholder="Select Employee"
							name="employee"
							value={values.employeeName}
							id="employee"
							onChange={data => {
								setFieldValue('employee', data.key);
								setFieldValue('employeeName', data.value);								
							}}
							data={toJS(employeeStore.mappedEmployees)}
							touched={touched.employee}
							error={errors.employee}
						/>
						<MimaInput
							type="number"
							labelTitle="Loan Amount"
							placeholder="Enter Employee Loan Amount"
							name="amountCollected"
							mb={2}
							value={values.amountCollected}
							onChange={handleChange}
							onBlur={handleBlur}
							error={errors.amountCollected}
							touched={touched.amountCollected}
						/>
						<MimaDateInput
							labelTitle="Disbursement date"
							name="disbursementDate"
							value={values.disbursementDate}
							onChange={text => {
								setFieldValue('disbursementDate', text);
							}}
							onBlur={handleBlur}
							touched={touched.disbursementDate}
							error={errors.disbursementDate}
							width={38}
						/>
						<MimaInput
							type="number"
							labelTitle="Repayment Cycle"
							placeholder="Repayment Cycle"
							name="rePaymentMonths"
							mb={2}
							value={values.rePaymentMonths}
							onChange={handleChange}
							onBlur={handleBlur}
							error={errors.rePaymentMonths}
							touched={touched.rePaymentMonths}
						/>
						<MimaDateInput
							labelTitle="Date of First Repayment"
							name="dateOfFirstRePayment"
							value={values.dateOfFirstRePayment}
							onChange={text => {
								setFieldValue('dateOfFirstRePayment', text);
							}}
							onBlur={handleBlur}
							touched={touched.dateOfFirstRePayment}
							error={errors.dateOfFirstRePayment}
							width={38}
						/>
						<MimaTextArea
							type="textarea"
							labelTitle="Description"
							placeholder="Enter a comment or description"
							name="description"
							mb={2}
							variant="message"
							value={values.description}
							onChange={handleChange}
							onBlur={handleBlur}
						/>

						<MimaButton
							title="Save"
							loading={loading}
							type="submit"
							onClick={handleSubmit}
						/>
					</div>
				)}
			</Formik>
		</Modal>
	);
};

export default AddLoan;
